// @ts-nocheck
import { ActionExtended } from "../../../_common/interfaces/ActionExtended";
import { ACTIONS } from "../../../_config";

export interface GlobalReducer {
  settings: any;
  seo_list: any;
  game_status_text: any;
}

const initialState: GlobalReducer = {
  settings: null,
  seo_list: null,
  game_status_text: null,
};

const globalsReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default globalsReducer;
